var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMask = function SvgMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4378_13616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.125 6.02267C3.125 5.89432 3.16451 5.76908 3.23817 5.66397C3.31183 5.55886 3.41607 5.47897 3.53672 5.43517L9.78672 3.16252C9.92451 3.11249 10.0755 3.11249 10.2133 3.16252L16.4633 5.43517C16.5839 5.47897 16.6882 5.55886 16.7618 5.66397C16.8355 5.76908 16.875 5.89432 16.875 6.02267V10.625C16.875 15 10 16.25 10 16.25C10 16.25 3.125 15 3.125 10.625V6.02267Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 8.125H13.125",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 10.625H13.125",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6729 11.875H17.5002C17.9975 11.875 18.4744 11.6775 18.826 11.3258C19.1777 10.9742 19.3752 10.4973 19.3752 10V8.125C19.3752 7.62772 19.1777 7.15081 18.826 6.79917C18.4744 6.44754 17.9975 6.25 17.5002 6.25H16.8752",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32734 11.875H2.5C2.00272 11.875 1.52581 11.6775 1.17417 11.3258C0.822544 10.9742 0.625 10.4973 0.625 10V8.125C0.625 7.62772 0.822544 7.15081 1.17417 6.79917C1.52581 6.44754 2.00272 6.25 2.5 6.25H3.125",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4378_13616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export default SvgMask;